import { dispatchExternalEvent, isBrowser } from '@sbt-web/utils';
import queueTask from 'post-task';

export function dispatchAsyncEvent(eventName: string): void {
  if (isBrowser()) {
    queueTask(() => dispatchExternalEvent(eventName), 'background');
  }
}
